import { useState, useEffect } from "react";
import { PRODUCT_ITEM_TYPE } from "../../components/Marketing/AdSetThirdParty/constants.js";
const isAdobeScriptReady = () => {
  return typeof adobe !== "undefined" && adobe.target && typeof adobe.target.getOffer === "function";
};
const useAdobe = (entry, keyword, contextData) => {
  const [adobeProductsResponse, setAdobeProductsResponse] = useState({
    products: []
  });
  const [adobeCategoryResponse, setAdobeCategoryResponse] = useState({
    categoryDisplayProperties: {},
    contentType: "",
    visitorFavCategories: ""
  });
  const { item_type, third_party_curation } = entry;
  const fetchAdobeOffers = (third_party_curation2) => {
    if (isAdobeScriptReady()) {
      const params = third_party_curation2.adobe_target_extension.params;
      if (keyword) {
        params.searchTerm = encodeURIComponent(keyword);
      }
      if (contextData && contextData["category_id"]) {
        params["entity.categoryId"] = contextData["category_id"];
      }
      adobe.target.getOffer({
        error: () => {
          console.error(
            `Error while fetching Adobe Ad set for mbox: ${third_party_curation2.adobe_target_extension.mbox}`
          );
        },
        mbox: third_party_curation2.adobe_target_extension.mbox,
        // MBOX NAME HERE
        params,
        // PUT PARAMETER NAME/VALUE PAIRS HERE WHEN PRESENT
        success: (response) => {
          if (Array.isArray(response) && response.length > 0 && (response[0].content || response[0].content.length > 0)) {
            item_type === PRODUCT_ITEM_TYPE && typeof response[0].content === "string" ? setAdobeProductsResponse(
              JSON.parse(response[0].content)
            ) : setAdobeCategoryResponse(
              response[0].content[0]
            );
          }
        }
      });
    } else {
      console.error("Adobe target script failed to load on page");
    }
  };
  useEffect(() => {
    fetchAdobeOffers(third_party_curation);
  }, [third_party_curation]);
  return { adobeCategoryResponse, adobeProductsResponse, fetchAdobeOffers };
};
export {
  isAdobeScriptReady,
  useAdobe
};
